module.exports = __webpack_public_path__ + "img/8_66.ce012667.png";